(function () {
	'use strict';
	angular.module('mx.SolutionBuilderAgent').component('mxDefinitionConditionsBuilder', {
		bindings: {
			value: '=?',
			value2: '<',
			value3: '=?',
		},
		controller: MxDefinitionConditionsBuilderCtrl,
		controllerAs: 'vm',
		template: '<mx-conditions-builder conditions-builder="vm.builder" ng-if="vm.builder">',
	});

	MxDefinitionConditionsBuilderCtrl.$inject = ['$scope', 'mx.SolutionBuilderAgent.DefinitionConditionsService'];

	function MxDefinitionConditionsBuilderCtrl($scope, definitionConditionsService) {
		var vm = this;
		var currentRules = [];

		vm.$onInit = function () {};

		$scope.$watchCollection('vm.value2', function (rules) {
			initBuilder(rules);
		});

		function initBuilder(rules) {
			currentRules = rules || '';
			definitionConditionsService.getBuilder(vm.value, currentRules).then(function (builder) {
				vm.builder = builder;
				if (builder) {
					vm.builder.onOutputChange = onOutputChange;
				}
				return builder;
			});
		}

		function onOutputChange(output) {
			vm.value = output.json;
			vm.value3 = output.query;
		}
	}
})();
